import { useFlags } from 'launchdarkly-react-client-sdk';

import { LD_DYNAMIC_TRANSLATION } from 'constants/featureFlags';

type DynamicTranslationsModelInfo = {
  /**
   * The name of the provider for the LLM model used for translation
   */
  provider: 'bedrock' | 'openai' | 'unknown';

  /**
   * The short name of the model the LLM used for translation
   */
  model: 'nova' | 'claude' | 'gpt' | 'unknown';

  /**
   * The exact model id of the model the LLM used for translation
   */
  modelId: string;
};

export const useDynamicTranslationsProviderName =
  (): DynamicTranslationsModelInfo => {
    const { [LD_DYNAMIC_TRANSLATION]: flag = 'off' } = useFlags();
    if (flag?.includes('nova')) {
      return {
        provider: 'bedrock',
        model: 'nova',
        modelId: flag,
      };
    } else if (flag?.includes('claude')) {
      return {
        provider: 'bedrock',
        model: 'claude',
        modelId: flag,
      };
    } else if (flag?.includes('gpt')) {
      return {
        provider: 'openai',
        model: 'gpt',
        modelId: flag,
      };
    } else {
      return {
        provider: 'unknown',
        model: 'unknown',
        modelId: flag,
      };
    }
  };
